import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import {MainNavBarModule} from '../../Elements/main-nav-bar/main-nav-bar.module';
import {MatTableModule} from '@angular/material/table';
import {RouterModule} from '@angular/router';
import {ExternalEmployeeRoutes} from './external-employee-application-routes';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NotFoundModule} from '../not-found/not-found.module';
import {FormListGeneratorModule} from '../../Elements/form-list-generator/form-list-generator.module';
import { ProductHomePageComponent } from './product-home-page/product-home-page.component';
import {MatTabsModule} from '@angular/material/tabs';
import {TableModule} from '../../Elements/table/table.module';
import { RequestDetailsComponent } from './request-details/request-details.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatCardModule} from '@angular/material/card';
import {DetailsDivModule} from '../../Elements/details-div/details-div.module';
import {CustomButtonModule} from '../../Elements/custom-button/custom-button.module';
import {FileUploadDivModule} from '../../Elements/file-upload-div/file-upload-div.module';
import {IntroductionLetterEmployeeResponseComponent} from './introduction-letter-employee-response/introduction-letter-employee-response.component';
import {
  RecompenseEmployeeResponseComponent
} from './recompense-employee-response/recompense-employee-response.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';



@NgModule({
  declarations: [
    HomeComponent,
    ProductHomePageComponent,
    RequestDetailsComponent,
    IntroductionLetterEmployeeResponseComponent,
    RecompenseEmployeeResponseComponent
  ],
  entryComponents: [],
  imports: [
    CommonModule,
    RouterModule.forChild(ExternalEmployeeRoutes),
    FormsModule,
    MainNavBarModule,
    ReactiveFormsModule,
    MatTableModule,
    NotFoundModule,
    FormListGeneratorModule,
    MatTabsModule,
    TableModule,
    MatExpansionModule,
    MatCardModule,
    DetailsDivModule,
    CustomButtonModule,
    FileUploadDivModule,
    MatDialogModule,
    MatButtonModule
  ]
})
export class ExternalEmployeeApplicationModule { }
